var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('router-view'),(_vm.$store.state.pendingRequestsCount)?_c('div',{staticClass:"preloader"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader_icon"},[_c('em',{staticClass:"icon fa fa-circle-o-notch fa-fw fa-spin"})])
}]

export { render, staticRenderFns }